module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hress5u-popup1",
      "id": "hress5u-popup1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UC5']['0']))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UC5']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "numreqst",
      "name": "numreqst"
    }
  }, [_vm._v(_vm._s(_vm.popup1DetailTab2.tab1.numreqst))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UC5']['30']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codpos",
      "name": "coddesc_codpos"
    }
  }, [_vm._v(_vm._s(_vm.popup1DetailTab2.tab1.codpos) + " - " + _vm._s(_vm.popup1DetailTab2.tab1.desc_codpos))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "accordion-tab2Popup1Tab1"
    }
  }, [_c('div', {
    staticClass: "panel box-collapse border-color-skin"
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion-tab2Popup1Tab1",
      "href": "#detailsPopup1Tab1"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRESS5UC5']['0']) + "\n\t\t\t          ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse in tab-detail",
    attrs: {
      "id": "detailsPopup1Tab1"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UC5']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "coddesc_codjob",
      "name": "coddesc_codjob"
    }
  }, [_vm._v(_vm._s(_vm.popup1DetailTab2.tab1.codjob) + " - " + _vm._s(_vm.popup1DetailTab2.tab1.desc_codjob))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UC5']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text width-100",
    attrs: {
      "id": "desnoffi",
      "name": "desnoffi"
    }
  }, [_vm._v(_vm._s(_vm.popup1DetailTab2.tab1.desnoffi))])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UC5']['0']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popup1DetailTab2.tab1.flgjob),
      expression: "popup1DetailTab2.tab1.flgjob"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Y",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "checked": Array.isArray(_vm.popup1DetailTab2.tab1.flgjob) ? _vm._i(_vm.popup1DetailTab2.tab1.flgjob, "Y") > -1 : (_vm.popup1DetailTab2.tab1.flgjob)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.popup1DetailTab2.tab1.flgjob,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Y",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.popup1DetailTab2.tab1, "flgjob", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.popup1DetailTab2.tab1, "flgjob", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.popup1DetailTab2.tab1, "flgjob", $$c)
        }
      }
    }
  }), _vm._v("\n                          " + _vm._s(_vm.labels['HRESS5UC5']['70']) + "\n\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.popup1DetailTab2.tab1.flgcond),
      expression: "popup1DetailTab2.tab1.flgcond"
    }],
    attrs: {
      "type": "checkbox",
      "value": "Y",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "checked": Array.isArray(_vm.popup1DetailTab2.tab1.flgcond) ? _vm._i(_vm.popup1DetailTab2.tab1.flgcond, "Y") > -1 : (_vm.popup1DetailTab2.tab1.flgcond)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.popup1DetailTab2.tab1.flgcond,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Y",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.popup1DetailTab2.tab1, "flgcond", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.popup1DetailTab2.tab1, "flgcond", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.popup1DetailTab2.tab1, "flgcond", $$c)
        }
      }
    }
  }), _vm._v("\n                          " + _vm._s(_vm.labels['HRESS5UC5']['80']) + "\n\t\t\t                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UC5']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text txtarea-width width-100",
    attrs: {
      "id": "syncond",
      "name": "syncond"
    }
  }, [_vm._v(_vm._s(_vm.popup1DetailTab2.tab1.syncond))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRESS5UC5']['100']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text txtarea-width width-100",
    attrs: {
      "id": "desnote",
      "name": "desnote"
    }
  }, [_vm._v(_vm._s(_vm.popup1DetailTab2.tab1.desnote))])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-195271b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hress5u/popup1.vue
// module id = 3597
// module chunks = 1